<template>
  <div>
    <div class="overview">
      <span class="percent">{{ masterBlock.value }}</span>
      <span class="name">{{ masterBlock.label }}</span>
      <span class="arrow" v-if="false"></span>
    </div>
    <div class="con">
      <div class="row" v-for="item in slaveBlock">{{ item.label }}：{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'block-config',
    typeCode: '6',
    data() {
      return {
        masterBlock: {},
        slaveBlock: []
      }
    },
    mounted() {
      this.masterBlock = this.data.items[0]
      for (let i = 1; i < this.data.items.length; i++) {
        this.slaveBlock.push(this.data.items[i])
      }
    }
  }
</script>

<style scoped>
  .overview {
    padding: 15px 0 10px;
    text-align: center;
  }

  .overview .percent {
    font-weight: 500;
    font-size: 36px;
    color: #565656;
  }

  .overview > span {
    display: block;
    line-height: 1;
  }

  .overview .name {
    margin-top: 8px;
    font-size: 13px;
    color: #666;
  }

  .overview > span {
    display: block;
    line-height: 1;
  }

  .overview .arrow {
    display: inline-block;
    margin-top: 15px;
    width: 0;
    height: 0;
    display: inline-block;
    overflow: hidden;
    border-width: 5px;
    border-color: transparent;
    border-style: dashed;
    border-top-color: #3b56ce;
    border-top-style: solid;
  }

  .overview > span {
    display: block;
    line-height: 1;
  }

  .con {
    margin: 0 auto;
  }

  .row {
    margin: 12px 20px;
    font-size: 14px;
    color: #666;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/block-config.vue